import gql from 'graphql-tag';

export const createFileOperation = gql`
  mutation CreateFileOperationMutation($input: CreateFileOperation!) {
    createFileOperation(input: $input) {
      id
    }
  }
`;
